import { useContext } from 'react'
import {
  WISHLIST_ENTRY_POINTS,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { GlobalProps } from '../../../utils/globalProps'

export function useWishlistEntryPoints(): boolean {
  const { experiments } = useContext(GlobalProps)

  const serverDecision = experiments?.[WISHLIST_ENTRY_POINTS]

  return (
    serverDecision === OPTIMIZELY_VARIANT_KEYS.WISHLIST_ENTRY_POINTS_VISIBLE
  )
}
